export default __webpack_public_path__ + "static/media/encryption_and_key_management.a7f81bc9.png";